import ApiRequestException from '../../exceptions/api-request-exception';
import {
  SET_AVAILABILITY_REQUEST,
  SET_AVAILABILITY_SUCCESS,
  SET_AVAILABILITY_FAILURE,
} from '../action-types';

export const setAvailability = (clubId, memberId, date, status, note) => async (dispatch) => {
  try {
    dispatch({
      type: SET_AVAILABILITY_REQUEST,
      payload: { clubId, memberId, date, status, note },
    });
    const { makeIsomorphicApiRequest } = await import('../../lib/api-proxy');
    const response = await makeIsomorphicApiRequest(
      `/v2/clubs/${clubId}/members/${memberId}/availability/${date}`,
      {
        method: 'PUT',
        body: JSON.stringify({ status, comment: note }),
      },
    );

    if (response.status !== 200) {
      throw new ApiRequestException('Error updating availability', response.status);
    }

    const data = await response.json();
    dispatch({
      type: SET_AVAILABILITY_SUCCESS,
      payload: { clubId, memberId, ...data },
    });
  } catch (error) {
    dispatch({
      type: SET_AVAILABILITY_FAILURE,
      payload: { clubId, memberId, date, status, note, error },
    });
  }
};
